import { Box, Image, Text } from '@zillow/constellation-10';
import PremiumBadge from '../../../../images/premium-badge.png';

interface Props {
  isPremiumListing: boolean;
  headingText: string;
}

export function ListingModuleHeading({ isPremiumListing, headingText }: Props) {
  return (
    <Box css={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      {isPremiumListing && <Image src={PremiumBadge} alt="premium badge" css={{ width: '35px' }} />}
      <Text
        className="ConnectedCard-Heading"
        asChild
        css={{
          marginRight: { base: '200', lg: '400' },
          textStyle: { base: 'body-bold', lg: 'heading-xs' },
        }}
      >
        <h2>{headingText}</h2>
      </Text>
    </Box>
  );
}
